import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import DriverCell from './DriverCell';
import { m } from '../../utils';
import './parking.css';

const DriversTable = ({ data = [], openParkingDialog, searchTerm = '' }) => {
  const getPrevious = () => {
    const currentTime = m();
    let prevShift;

    if (currentTime.isSameOrAfter(m().hour('22'))) {
      // after 11 pm today?
      prevShift = '3 PM - 11 PM';
    } else if (currentTime.isSameOrAfter(m().hour('14'))) {
      // afer 3 pm today?
      prevShift = '7 AM - 3 PM';
    } else if (currentTime.isSameOrAfter(m().hour('6'))) {
      // after 7 am today?
      prevShift = '11 PM - 7 AM';
    } else if (currentTime.isBefore(m().hour('6'))) {
      // after 11 pm yesterday?
      prevShift = '3 PM - 11 PM';
    } else {
      prevShift = null;
    }
    return prevShift;
  };

  const getCurrent = () => {
    const currentTime = m();
    let currentShift;

    if (currentTime.isBefore(m().hour('6'))) {
      // before 7 am today?
      currentShift = '11 PM - 7 AM';
    } else if (currentTime.isBefore(m().hour('14'))) {
      // before 3 pm today?
      currentShift = '7 AM - 3 PM';
    } else if (currentTime.isBefore(m().hour('22'))) {
      // before 11 pm today?
      currentShift = '3 PM - 11 PM';
    } else if (currentTime.isSameOrAfter(m().hour('22'))) {
      // after 11 pm today?
      currentShift = '11 PM - 7 AM';
    } else {
      currentShift = null;
    }
    return currentShift;
  };

  const columns = [
    {
      Header: `PREVIOUS (${getPrevious()})`,
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        padding: 0,
      },
      Cell: _data => (
        <DriverCell
          props={_data}
          type="prevBooking"
          openParkingDialog={openParkingDialog}
          searchTerm={searchTerm}
          className="cell-override"
        />
      ),
    },
    {
      Header: `CURRENT (${getCurrent()})`,
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        padding: 0,
      },
      Cell: _data => (
        <DriverCell
          props={_data}
          type="currentBooking"
          className="cell-override"
          openParkingDialog={openParkingDialog}
          searchTerm={searchTerm}
        />
      ),
    },
    {
      Header: 'PLATE',
      accessor: 'plate',
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  ];
  return <ReactTable data={data} columns={columns} className="-striped -highlight" />;
};

export default DriversTable;



// WEBPACK FOOTER //
// ./src/components/Parking/DriversTable.js